<!--选择企业员工信息-->

<template>
    <div style="display:flex;flex-direction: row;align-items: center;">
        <el-select v-model="selectValue" filterable clearable :placeholder="placeholder" @change="change"
            :disabled="disabled">
            <el-option v-for="item in listOptions" :label="item.label" :value="parseInt(item.value)">
            </el-option>
        </el-select>
    </div>
</template>

<script>
import {
    pullList
} from '@/api/admin/sysEnterprise/index';
export default {
    props: {
        value: {
            type: Number,
            default: 0,
        },
        entType: {
            type: String,
            default: 0,
        }
    },
    data() {
        return {
            //是否禁止
            disabled: false,
            //默认提示语
            placeholder: "请选择",
            //选中的值
            selectValue: null,
            //list列表值
            list: [],
            //查询条件
            query: {},
        }
    },
    created() {
        if (this.value) {
            this.selectValue = this.value;
        }
        this.init();
    },
    watch: {
        value(n) {
            this.selectValue = n;
        },
    },
    computed: {
        "listOptions"() {
            return this.handleLabelValue(this.list, "entId", "entName") || [];
        }
    },
    methods: {
        init() {
            this.queryList();
        },
        queryList() {
            let query = this.query;
            if (this.entType) {
                Object.assign(query, { "entTypes": [parseInt(this.entType)] })
            }

            pullList(query).then(response => {
                this.list = response || [];
            })
        },
        handleLabelValue(list, value = "id", label = "name") {
            return [...list].map(x => {
                Object.assign(x, { "value": x[value], "label": x[label] });
                return x
            });
        },
        change(selectValue) {
            // console.log("选中：", id)
            let matchs = this.listOptions.filter(x => x.value == selectValue);
            let match = matchs.length > 0 ? matchs[0] : {};
            // console.log("选中2：", match)
            this.$emit("input", selectValue);
            this.$emit("changeInfo", match);
        }

    }
}
</script>

<style scoped></style>